
const state = {
    isApp: false
}
const getters = {

}
const actions = {
    initState({ commit }) {
        const ua = navigator.userAgent;
        const temp = ua.indexOf('QJWAPP') > -1;
        commit('setState', temp)
    }
}

const mutations = {
    setState(state, data) {
        state.isApp = data;
    }
}


export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js